import { certificateStatusLabel, participationStatusLabel } from "./attendanceLabels";

type Session = { id: string; title: string };
type Participant = {
  id: number;
  name: string;
  email: string;
  phone?: string;
  document: string;
  participationStatus: string;
  attendances: Array<{ session_id: string; status: string }>;
  content?: { progress: { percentage: number; completedItems: number; requiredItems: number } };
  certificate?: { certificateStatus: string };
};

const attendanceStatusLabel = (status?: string) => {
  if (status === "PRESENT") return "Presente";
  if (status === "REVOKED") return "Presença revogada";
  return "Ausente";
};

export const buildAttendanceExportRows = (participants: Participant[], sessions: Session[]) =>
  participants.map((participant) => {
    const progress = participant.content?.progress;
    const row: Record<string, string | number> = {
      Inscrição: participant.id,
      Nome: participant.name,
      CPF: participant.document,
      Telefone: participant.phone || "",
      "E-mail": participant.email,
      Participação: participationStatusLabel(participant.participationStatus),
      "Progresso do conteúdo": `${progress?.percentage || 0}%`,
      "Conteúdos concluídos": progress?.completedItems || 0,
      "Conteúdos obrigatórios": progress?.requiredItems || 0,
      Certificado: participant.certificate
        ? certificateStatusLabel(participant.certificate.certificateStatus)
        : "Não configurado",
    };

    sessions.forEach((session) => {
      const attendance = participant.attendances.find((item) => item.session_id === session.id);
      row[`Presença — ${session.title}`] = attendanceStatusLabel(attendance?.status);
    });

    return row;
  });
